import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocale } from "src/hooks/use-locale";
import "src/infra/i18n/i18next-config";

// 添加变量替换函数（基于标准体系的实现）
const compileText = (template: string, variables: string[]): string => {
  let result = template;
  variables.forEach((variable, i) => {
    result = result.replace(`\${${i + 1}}`, variable);
  });
  return result;
};

// export const useTranslate = () => {
//   const { t } = useTranslation();
//   const { isI18nReady } = useLocale();

//   const translate = useCallback(
//     (key: string, ...variables: string[]): string => {
//       if (!isI18nReady) {
//         return key;
//       }

//       const interpolationOptions: Record<string, string> = {};
//       variables.forEach((variable, index) => {
//         interpolationOptions[`${index + 1}`] = variable;
//       });

//       return t(key, interpolationOptions);
//     },
//     [t, isI18nReady],
//   );

//   return translate;
// };

export const useTranslate = () => {
  const { t } = useTranslation();
  const { isI18nReady } = useLocale();

  const translate = useCallback(
    (key: string, ...variables: string[]): string => {
      if (!isI18nReady) {
        return key;
      }

      // 获取翻译模板
      const template = t(key);

      // 如果没有变量参数，直接返回翻译文本
      if (variables.length === 0) {
        return template;
      }

      // 使用自定义的 compileText 进行占位符替换
      return compileText(template, variables);
    },
    [t, isI18nReady],
  );

  return translate;
};
